import { axiosInstance } from "../axiosInstance";

export const getAllServices =async () => {
  const instance =await axiosInstance();
  return await instance.get("/package/service/all");
};
